import { Content } from "@jobber/components/Content";
import { Heading } from "@jobber/components/Heading";
import { Text } from "@jobber/components/Text";
import { Button } from "@jobber/components/Button";

function Error() {
    return (
        <div
            style={{
                width: "100%",
                minHeight: "371px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
            }}
        >
            <Content type={"div"} spacing={"base"}>
                <Heading level={2}>Something went wrong</Heading>
                <Text size={"large"}>
                    Please try again and contact our support team if the issue persists.
                </Text>
              <Button
                  url="https://secure.getjobber.com/marketplace"
                  label="Try Again"
                  type="primary"
              />
            </Content>
        </div>
    );
}

export default Error;
